export const initScrollEl = function() {
  //   Скролл табов. START
  const parent = document.querySelector('[data-btn-scroll="parent"]');

  if (parent) {
    const parentTab = parent.querySelectorAll('[data-btn-scroll="btn"]');

    parentTab.forEach((item) => {
      item.addEventListener('click', () => {
        let scrollLeftTab;
        const railsWidth = parent.clientWidth;
        const railsWidthLeft = parent.getBoundingClientRect().left;
        const tabWidth = item.offsetWidth;

        const tabLeftOffset = item.getBoundingClientRect().left;
        // eslint-disable-next-line prefer-const
        scrollLeftTab = Number(tabLeftOffset - (
          railsWidth / 2
        ) + (
          tabWidth / 2
        ) - railsWidthLeft);

        parent.scrollBy({
          left: scrollLeftTab,
          behavior: 'smooth'
        });

      });
    });
  }
  //   Скролл табов. END

  //   Скролл таблицы START

  const scrollParentTable = document.querySelectorAll('[data-scroll="parent"]');

  if (scrollParentTable.length > 0) {
    scrollParentTable.forEach((el) => {
      const scrollTableBtnNext = el.querySelector('[data-scroll="btn-next"]');
      const scrollTableBtnPrev = el.querySelector('[data-scroll="btn-prev"]');
      const scrollTableContainer = el.querySelector('[data-scroll="container"]');
      const scrollTableElement = el.querySelector('[data-scroll="element"]');

      if (scrollTableBtnNext) {
        scrollTableBtnNext.addEventListener('click', (e) => {
          const scrollPx = 307;
          scrollTableContainer.scrollBy({
            left: scrollPx,
            behavior: 'smooth'
          });
        });
      }

      if (scrollTableBtnPrev) {
        scrollTableBtnPrev.addEventListener('click', (e) => {
          const scrollPx = -307;
          scrollTableContainer.scrollBy({
            left: scrollPx,
            behavior: 'smooth'
          });
        });
      }

      const scrollWidthLeftStart = scrollTableContainer.scrollLeft;
      const scrollWidthMoreStart = scrollTableElement.offsetWidth - scrollTableContainer.offsetWidth;

      if (scrollWidthLeftStart > scrollWidthMoreStart) {
        scrollTableBtnNext.classList.add('is-hidden');
        scrollTableBtnPrev.classList.add('is-hidden');
      }

      if (scrollTableContainer) {
        scrollTableContainer.addEventListener('scroll', (e) => {
          if (scrollTableContainer.scrollLeft === 0) {
            scrollTableBtnPrev.setAttribute('disabled', 'disabled');
          } else {
            scrollTableBtnPrev.removeAttribute('disabled');
          }
          const scrollWidthLeft = scrollTableContainer.scrollLeft;
          const scrollWidthMore = scrollTableElement.offsetWidth - scrollTableContainer.offsetWidth;

          if (scrollWidthMore === scrollWidthLeft) {
            scrollTableBtnNext.setAttribute('disabled', 'disabled');
          } else {
            scrollTableBtnNext.removeAttribute('disabled');
          }
        });
      }
    });
  }
  //   Скролл таблицы END

};
